import styled, { css } from 'styled-components'

import { TradeSettingsPresetForm } from '@root/widgets/trade/trade-settings/desktop'

import { InstantTradeBottomPopover } from './instant-trade-bottom-popover'

import type { ChildrenProps } from '@root/shared/react'

type Props = {} & ChildrenProps

export const InstantTradeBottomSettings: React.FC<Props> = ({ children }) => {
  return (
    <Popover
      type="settings"
      content={
        <TradeSettingsPresetForm
          css={css`
            --quick-option-inactive-border: var(--background-6);
          `}
        />
      }
    >
      {children}
    </Popover>
  )
}

const Popover = styled(InstantTradeBottomPopover)`
  height: auto;
  width: 325px;
`
